import React from 'react';
import { LayoutDashboard, Warehouse, ClipboardList, Clock, FileBarChart2 } from 'lucide-react';
import { useTheme } from '../../core/ui/ThemeContext';
import { useLanguage } from '../../core/i18n/LanguageContext';

/**
 * LagerSidebar — Modul-Navigation fuer das Lager-Modul.
 * Props:
 *   activeSection  string   aktiver Eintrag ('dashboard'|'lagerbestand'|'banf-status'|'durchlaufzeiten'|'berichte')
 *   onSelect       (section: string) => void
 */
const LagerSidebar = ({ activeSection, onSelect }) => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();

  const navItems = [
    { id: 'dashboard',       icon: LayoutDashboard,  labelKey: 'lm.navDashboard',       enabled: true  },
    { id: 'lagerbestand',    icon: Warehouse,         labelKey: 'lm.navLagerbestand',    enabled: true  },
    { id: 'banf-status',     icon: ClipboardList,     labelKey: 'lm.navBanfStatus',      enabled: true  },
    { id: 'durchlaufzeiten', icon: Clock,             labelKey: 'lm.navDurchlaufzeiten', enabled: true  },
    { id: 'berichte',        icon: FileBarChart2,     labelKey: 'lm.navBerichte',        enabled: true  },
  ];

  const sidebarBg = isDarkMode
    ? 'bg-gray-900/60 border-r border-white/8 backdrop-blur-xl'
    : 'bg-white border-r border-slate-200';

  const itemBase = 'flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all w-full text-left';

  const itemActive = isDarkMode
    ? 'bg-brand/20 text-blue-200 border border-brand/25'
    : 'bg-brand/10 text-brand border border-brand/20';

  const itemIdle = isDarkMode
    ? 'text-white/60 hover:text-white hover:bg-white/8'
    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100';

  const itemDisabled = isDarkMode
    ? 'text-white/25 cursor-default'
    : 'text-slate-300 cursor-default';

  return (
    <aside className={`flex-shrink-0 w-52 flex flex-col py-4 px-3 ${sidebarBg}`}>
      <nav className="flex flex-col gap-1">
        {navItems.map(({ id, icon: Icon, labelKey, enabled }) => {
          const isActive = activeSection === id;
          if (!enabled) {
            return (
              <div
                key={id}
                className={`${itemBase} ${itemDisabled}`}
                title={t('lm.dashSoon')}
              >
                <Icon className="w-4 h-4 flex-shrink-0" />
                <span className="truncate">{t(labelKey)}</span>
              </div>
            );
          }
          return (
            <button
              key={id}
              type="button"
              onClick={() => onSelect(id)}
              className={`${itemBase} ${isActive ? itemActive : itemIdle}`}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon className="w-4 h-4 flex-shrink-0" />
              <span className="truncate">{t(labelKey)}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default LagerSidebar;
